import { Injectable } from '@angular/core';
import { ProjectType } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectDropServiceService {

  isShowProjectType : ProjectType;
  showProjectType : BehaviorSubject<ProjectType> = new BehaviorSubject<ProjectType>(null);


  constructor() {
    this.showProjectType.subscribe(res => {
      this.isShowProjectType;
    })
   }

  
}
